import React from "react";
import "../styles/GifLoader.css"; // Make sure this file exists

import loaderGif from "../assets/loader.gif"

const GifLoader = () => (
  <div className="gif-loader">
    <img src={loaderGif} alt="Loading..." />
  </div>
);

export default GifLoader;
